<template>
  <div class="coin_dealer">
    <!-- 顶部导航栏 -->
    <van-nav-bar placeholder safe-area-inset-top :title="$t('title.agent_account')" @click-left="goBack" left-arrow >
       <template #right>
        <img src="../assets/img/coin_dealer/coin_dealer_log.png" alt="" height="20vw" @click="dealerRule">
      </template>
    </van-nav-bar>
    <van-row>
      <van-col span="24" class="coin_dealer_overview">
       <!-- 绑定支付方式和等级排名 -->
        <van-col span="22" offset="1" class="info-row">
            <van-col span="12" @click="showPaymentMethod">
                <van-col span="24" class="info-label">{{ $t('column.payment_method')}}</van-col>
                <van-col span="20" class="info-content">
                <img :src="country_img" class="info-content-img" v-if="country_img"/> <van-icon name="arrow" size="14" />
                </van-col>
            </van-col>
            <van-col span="12"  @click="showRanking">
                <van-col span="24" class="info-label">{{ $t('column.coinseller_rank')}}</van-col>
                <van-col span="16" class="info-content">
                <van-image
                    v-for="(item, index) in coinselller_rank"
                    :key="index"
                    round width="20" height="20"
                    :src="item.head_image"
                    :style="{ marginLeft: index > 0 ? '-8px' : '0' }"
                />
                <van-icon name="arrow" size="14" />
                </van-col>
            </van-col>
        </van-col>
         <van-col span="22" offset="1" class="coin_dealer_bg">    
            <van-col span="14" offset="1" class="coin_dealer_bg_title">    
                <img src="../assets/img/coin10.png" alt="" height="10vw"> {{ $t('column.Coins_Trading')}}
            </van-col>
            <van-col span="8" class="coin_dealer_bg_right" @click.native="showDetails()"> {{ $t('column.details')}} </van-col>
            <van-col span="22" offset="1" class="coin_dealer_bg_coin"> {{ availableBalance }} </van-col>
            <van-col span="22" offset="1" class="coin_dealer_bg_btn">
                <van-button color="#7232dd" class="coin_dealer_bg_btn_exchange"  @click="coin_dealer_recharge_exchange(2)" plain round :icon="coin9"> {{ $t('column.exchange')}} </van-button>
                <van-button color="#ffffff" class="coin_dealer_bg_btn_top_up" @click="coin_dealer_recharge_exchange(1)" round > {{ $t('agent.recharge')}} </van-button>
            </van-col>
         </van-col>
         <van-col span="24" class="coin_dealer_transfer">
             <!--    transfer 转让      -->
            <van-col span="22" offset="1">
              <van-col span="10" class="action-content-transfer-type-name"> {{ $t('column.sales_methods')}}: </van-col>
              <van-col span="14" class="action-content-transfer-type">
                <van-tabs v-model="TransferActiveType" @click="TransferActiveTypeBtn" class="action-content-transfer-type-tabs" type="card" color="#ffffff" background="#EDF2F8" title-active-color="#1A1A1A" title-inactive-color="#5E5D65">
                  <van-tab title="User" name="User"></van-tab>
                  <van-tab title="Coinseller" name="CoinSeller"></van-tab>
                </van-tabs>
              </van-col>
              <van-col span="24" class="action-content-transfer-title">{{ $t('column.user_id')}}:</van-col>
              <van-col span="24" class="action-content-transfer-input">
                <van-field v-model="transferFrom.user_id" :placeholder="$t('column.please_input_user_id')"  @input="transferFromMonitorUserId">
                  <template #button>
                    <van-button size="small" @click="checkUserId">{{ $t('column.check')}}</van-button>
                  </template>
                </van-field>
              </van-col>
              <van-col span="24" class="action-content-transfer-name" v-if="transferFrom.nick_name"> <img :src="transferFrom.head_image"/> {{ transferFrom.nick_name }} </van-col>
              <van-col span="24" class="action-content-transfer-title">{{ $t('column.amount')}}:</van-col>
              <van-col span="24" class="action-content-transfer-input">
                <van-field v-model="transferFrom.coin" :placeholder="$t('column.please_enter')"  @input="transferFromMonitor"/>
              </van-col>
              <van-col span="24" class="action-content-transfer-text">
                {{ $t('column.will_receive_diamonds')}}:
                {{ transferFrom.ticket }}
                <img src="../assets/img/coin11.png" v-if="TransferActiveType == 'User'"/><img src="../assets/img/coin10.png" v-else/>
              </van-col>
                <van-col span="24" class="action-content-transfer-img">  
                    <van-swipe class="my-swipe" :autoplay="3000">
                       <van-swipe-item v-for="(item, index) in index_image" :key="index" @click="jump_url(item)">
                         <img :src="item.image" alt="" />
                      </van-swipe-item>
                     
                    </van-swipe>
                </van-col>
               
              <van-col span="22" offset="1" class="action-content-transfer-botton">
                <van-button color="#E4BEFF" block round v-if="!this.transferFrom.coin || !transferFrom.nick_name">{{ $t('column.Transfer')}}</van-button>
                 <van-button color="#FF61F5" block round @click="TransferBtn" v-else>{{ $t('column.Transfer')}}</van-button>
              </van-col>
            </van-col>
         </van-col>
      </van-col>
       
      <van-dialog v-model="payment_method_show" show-cancel-button :close-on-click-overlay="false">
        <van-col span="24" class="payment_method_show_title"> {{ $t('column.please_finish_first')}}  </van-col>
        <van-col span="20" offset="2" class="payment_method_show_add" @click.native="CurrencyTypeShowBtn">
          <van-icon name="plus" color="#FF61F5" size="18px" /> {{ $t('column.add_payment_method') }}
        </van-col>
      </van-dialog>
      <van-popup v-model="CurrencyTypeShow" position="bottom"  round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in currency_type" :key="index" @click="jump_href(item.currency_type_id)">
            <van-col span="12" class="currency_type_list_name"> <img :src="item.country_img"/> {{ item.country_name }} </van-col>
            <van-col span="12" class="currency_type_list_item_content"> {{ item.currency_name }} <van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
      <van-dialog v-model="dealer_level_show" show-cancel-button :close-on-click-overlay="true">
        <van-col span="24" class="dealer_level_show_img">
          <img src="../assets/img/coin_dealer/dealer_level_title.png"/>
        </van-col>
        <van-col span="24" class="dealer_level_show_title"> {{ $t('column.first_level_up')}} </van-col>
        <van-col span="20" offset="2" class="dealer_level_show_center"> {{ $t('column.level_up_and_unlock')}} </van-col>
        <van-col span="18" offset="3" class="dealer_level_show_btn">
          <van-button color="#FF61F5" block @click="dealerRule">{{ $t('column.level_up')}}</van-button>
        </van-col>
      </van-dialog>

    </van-row>

  </div>
</template>

<script>
import '@/assets/css/style.css'
import Toast from 'vant/lib/toast'
import axios from "axios";
import {Dialog} from "vant";
import { judgeIosAndroid } from '@/assets/js/models.js'

export default {
  name: 'CoinDealer',
  data() {
    return {
      coin9: require('../assets/img/coin9.png'),
      CurrencyTypeShow: false,
      dealer_level_show: false,
      transferFrom:{
        user_id: undefined,
        coin: undefined,
        ticket: undefined,
        nick_name: undefined,
        head_image: undefined
      },
      seller_currency_name: undefined,
      totalBalance: '0',
      availableBalance: '0',
      securityDeposit: '0',
      userInfo: {},
      coinselller_rank: [],
      currency_type: [],
      country_img: undefined,
      payment_method_show: false,
      TransferActiveType: 'User',
      buyer_type_list: [
        {id:0, name: 'ALL'},
        {id:1, name: 'User'},
        {id:2, name: 'Reseller'}
      ],
      loading: false,
      finished: false,
      page: 1,
      index_image: []
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    dealerRule() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_dealer_rule', query: { uid: uid, token: token } });
    },
    jump_url(item) {
      if(item.url){
        // 拦截内部链接
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.jump_internal_link.postMessage(item.url)
        } else {
          // Android传值方法传值方式-跳转内部链接
          window.AndroidJs.jump_internal_link(item.url)
        }
      }
    },
    jump_href(currency_type_id) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_payment_method_select', query: { uid: uid, token: token, currency_type_id: currency_type_id } });
    },
    coin_dealer_recharge_exchange(type) {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        this.$router.push({ path: '/coin_dealer_recharge_exchange', query: { uid: uid, token: token, type: type } });
    },
    TransferActiveTypeBtn() {
      this.transferFrom.user_id = undefined
      this.transferFrom.coin = undefined
      this.transferFrom.ticket = undefined
      this.transferFrom.nick_name = undefined
      this.transferFrom.head_image = undefined

      if(this.TransferActiveType == 'User'){
        if(this.userInfo.transfer_user_active != 1){
          // 没有权限
          this.dealer_level_show = true
        }
      } else{
        if(this.userInfo.transfer_seller_active != 1){
          // 没有权限
          this.dealer_level_show = true
        }
      }
    },
    checkUserId() {
      if(!this.transferFrom.user_id){
        Toast(this.$t('other.Please_input_user_id'))
        return
      }
      // 检测用户是否存在
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=check_user_or_coin_seller_exist",{
        params:{uid: uid, token: token, to_user_id: this.transferFrom.user_id, transfer_type: this.TransferActiveType }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if (res.data.status===1){
          this.transferFrom.nick_name = res.data.data.nick_name
          this.transferFrom.head_image = res.data.data.head_image
        }else{
          Toast(res.data.error)
        }
      })
    },
    transferFromMonitor(value) {
      this.transferFrom.coin = value.replace(/[^\d]/g, '');
      if (this.TransferActiveType === 'User'){
        // 转让给用户
        this.transferFrom.ticket = Math.floor(this.transferFrom.coin * this.userInfo.seller_user_rate)
      } else {
        // 转让给机构
        this.transferFrom.ticket = Math.floor(this.transferFrom.coin * this.userInfo.seller_merchant_rate)
      }
    },
    transferFromMonitorUserId(value){
      this.transferFrom.user_id = value.replace(/[^\d]/g, '');
    },
    CurrencyTypeShowBtn() {
      this.payment_method_show = false
      this.CurrencyTypeShow = true
    },
    get_list(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_coin_dealer_info",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.userInfo = res.data.data.userInfo
          this.currency_type = res.data.data.currency_type
          this.coinselller_rank = res.data.data.coinselller_rank
          this.country_img = res.data.data.country_img
          this.payment_method_show =  !this.country_img
          this.availableBalance = res.data.data.userInfo.coin
          this.securityDeposit = res.data.data.userInfo.deposit_coin
          this.totalBalance = parseInt(this.availableBalance) + parseInt(this.securityDeposit)

          this.seller_recharge_multiple = res.data.data.seller_recharge_multiple
          this.seller_currency_name = res.data.data.seller_currency_name
          this.index_image = res.data.data.index_image

        }else{
          Toast(res.data.error)
        }
      })
    },
    goBack() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    showPaymentMethod() {
      if (this.country_img) {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        this.$router.push({ path: '/coin_seller_payment_method', query: { uid: uid, token: token } });
      } else {
        this.payment_method_show = true
      }
    },
    showRanking() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_ranking', query: { uid: uid, token: token } })
    },
    showDetails() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/coin_seller_details', query: { uid: uid, token: token } })
    },
    TransferBtn(){
      if (this.userInfo.transfer_user_active == 0 && this.userInfo.transfer_seller_active == 0){
        // 没有权限
        this.dealer_level_show = true
        return false
      }
      Dialog.confirm({
        title: this.$t('column.transfer_to_current_account'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=coin_seller_transfer",{
          params:{uid: uid, token: token, to_user_id: this.transferFrom.user_id, transfer_type: this.TransferActiveType, coin: this.transferFrom.coin,no_deposit_coin: 1}
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status !==1){
            Toast(res.data.error)
          }else{
            this.TransferActiveTypeBtn()
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.get_list()
              }
            });
          }
        })
      }).catch(() => {
        // on cancel
      });
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/coin_dealer.vue